import { useState } from "react";
import { useTranslation } from "react-i18next";

import { api } from "../../../lib/api";
import { getApiErrorMessage, normalizeLang } from "../../../lib/apiErrorMessage";

/** Same authenticated blank workbook from collection and import; no census mutation. */
export function DownloadCensusTemplate() {
  const { t, i18n } = useTranslation();
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);
  async function download() {
    setBusy(true);
    setError(null);
    try {
      await api.download("/v1/censuses/template.xlsx", "kollectivia-effectif.xlsx");
    } catch (err) {
      setError(
        getApiErrorMessage(err, normalizeLang(i18n.language)) || t("census.import.error_generic"),
      );
    } finally {
      setBusy(false);
    }
  }
  return (
    <div className="mb-4">
      <button
        type="button"
        disabled={busy}
        onClick={() => void download()}
        className="text-brand-600 focus-visible:ring-brand-500 min-h-11 rounded-lg border border-slate-300 px-3 py-2 text-sm hover:bg-slate-50 focus-visible:outline-none focus-visible:ring-2 disabled:opacity-50"
      >
        {t(busy ? "census.import.template_loading" : "census.import.template_download")}
      </button>
      {error ? (
        <p role="alert" className="mt-2 text-sm text-red-600">
          {error}
        </p>
      ) : null}
    </div>
  );
}
